const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://aurndsseayntpnjwgnlw.supabase.co';
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || 'sb_publishable_DCQINAtZWdDqeWUV41t6tA_VBQ_0EEY';

export async function loadWebsiteExperience() {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/rpc/app_website_experience`, {
    method: 'POST',
    headers: {
      apikey: SUPABASE_KEY,
      Authorization: `Bearer ${SUPABASE_KEY}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ p_branch_code: process.env.REACT_APP_BRANCH_CODE || '01' })
  });
  if (!res.ok) throw new Error(`Website catalog unavailable (${res.status})`);
  return res.json();
}
